// ----------------------------------------------------------------------------
// Component: Statement Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

import './_statement-block.scss';

// -------------------------------------
// Hooks
// -------------------------------------

var stats = $('.stat-blocks');

if (stats.length > 0) {
    var counted = false;
    $(window).on('scroll', function() {
        var statsTop = $('.stat-blocks').offset().top - window.innerHeight;
        if (!counted && $(window).scrollTop() > statsTop) {
            $('.stat__number').each(function() {
                var $this = $(this),
                countTo = $this.attr('data-count');

                
                $({countNum: 0})
                .animate({
                    countNum: countTo
                },
                {
                    duration: 2000,
                    easing: 'swing',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text((this.countNum).toLocaleString(undefined,{ minimumFractionDigits: 0 }));
                    }
                });
            });

            counted = true;
        }
    });
}